import AdminProfilePhotoIcon from './component'

export default AdminProfilePhotoIcon
